// extracted by mini-css-extract-plugin
module.exports = {"item":"RewardItem_item__srUjX","image":"RewardItem_image__yH0cW"};